export const GLOBALS = {
    MEDIA_IMAGE_HOST: 'static.wixstatic.com',
    DUPLEXER_URL: 'duplexer.wix.com',
    /** comma-separated string */
    DISABLE_DUPLEXER_FOR_INSTANCE_IDS: '671e6bcb-a0a9-4ae0-98f2-f81a607bf167',
    API_BASE_URL_CLIENT: '/_api/communities-blog-node-api',
    API_PLATFORMIZED_BASE_URL: 'https://www.wix.com/_api/communities-blog-api-web',
    MEDIA_VIDEO_HOST: 'video.wixstatic.com',
    API_PLATFORMIZED_BASE_URL_CLIENT: '/_api/communities-blog-api-web',
    API_BASE_URL: 'https://apps.wix.com/_api/communities-blog-node-api',
    API_AGGREGATOR_BASE_URL: '/blog-frontend-adapter-public',
    API_EXPERIMENTS_BASE_URL_CLIENT: '/_api/wix-laboratory-server',
    API_PAYWALL_BASE_URL: '/_api/paywall-server',
};
//# sourceMappingURL=globals.js.map